module.exports = __webpack_public_path__ + "static/media/catalouge-41.27ef0f38.jpg";